import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import '../../contexts/MicrositeMenuContext/index.mjs';
import './components/HeaderContent/index.mjs';
import { useMicrositeMenu } from '../../contexts/MicrositeMenuContext/context.mjs';
import { HeaderContent } from './components/HeaderContent/HeaderContent.mjs';
"use strict";
const MicrositeHeader = ({
  onMenuItemClick,
  onLanguageChange,
  account,
  motif
}) => {
  const {
    menu
  } = useMicrositeMenu();
  const firstLevelItems = useMemo(() => menu.items, [menu.items]);
  const firstLevelActiveItem = useMemo(() => firstLevelItems?.find(item => item.active), [firstLevelItems]);
  const secondLevelItems = useMemo(() => firstLevelActiveItem?.variant !== "dropdown" ? firstLevelActiveItem?.items : void 0, [firstLevelActiveItem]);
  return /* @__PURE__ */jsx(HeaderContent, {
    menu,
    motif,
    account,
    onLanguageChange,
    onMenuItemClick,
    isLastMenu: !secondLevelItems?.length
  });
};
export { MicrositeHeader };
//# sourceMappingURL=MicrositeHeader.mjs.map
